import { render, staticRenderFns } from "./ButtonFullscreen.vue?vue&type=template&id=be08063a&scoped=true&"
import script from "./ButtonFullscreen.vue?vue&type=script&lang=ts&"
export * from "./ButtonFullscreen.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonFullscreen.vue?vue&type=style&index=0&id=be08063a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be08063a",
  null
  
)

export default component.exports